import debug from 'debug';

const log = debug('Debounce');

class Debounce {
	
	constructor() {}

	debounce(fn, time) {
		let timeout;

		log('debouncing for', time)
		
		return function () {
			const functionCall = () => fn.apply(this, arguments);

			clearTimeout(timeout);
			timeout = setTimeout(functionCall, time);
		}
	}
}

export default Debounce;

export { Debounce };
